@file:OptIn(InternalResourceApi::class)

package mapl.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mapl.composeapp.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_203_444_826)
internal val Res.drawable.ic_back: DrawableResource by lazy {
      DrawableResource("drawable:ic_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_back.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_653_456_667)
internal val Res.drawable.ic_delete: DrawableResource by lazy {
      DrawableResource("drawable:ic_delete", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_delete.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_446_194_211)
internal val Res.drawable.ic_info: DrawableResource by lazy {
      DrawableResource("drawable:ic_info", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_info.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-973_996_726)
internal val Res.drawable.ic_payments: DrawableResource by lazy {
      DrawableResource("drawable:ic_payments", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_payments.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-23_359_292)
internal val Res.drawable.ic_qr_code: DrawableResource by lazy {
      DrawableResource("drawable:ic_qr_code", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_qr_code.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_417_902_394)
internal val Res.drawable.ic_stop: DrawableResource by lazy {
      DrawableResource("drawable:ic_stop", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_stop.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_308_933_191)
internal val Res.drawable.suit_kule: DrawableResource by lazy {
      DrawableResource("drawable:suit_kule", setOf(
        ResourceItem(setOf(), "${MD}drawable/suit_kule.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(104_362_352)
internal val Res.drawable.suit_lepsi: DrawableResource by lazy {
      DrawableResource("drawable:suit_lepsi", setOf(
        ResourceItem(setOf(), "${MD}drawable/suit_lepsi.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_044_569_071)
internal val Res.drawable.suit_zaludy: DrawableResource by lazy {
      DrawableResource("drawable:suit_zaludy", setOf(
        ResourceItem(setOf(), "${MD}drawable/suit_zaludy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-171_804_007)
internal val Res.drawable.suit_zelene: DrawableResource by lazy {
      DrawableResource("drawable:suit_zelene", setOf(
        ResourceItem(setOf(), "${MD}drawable/suit_zelene.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_back", Res.drawable.ic_back)
  map.put("ic_delete", Res.drawable.ic_delete)
  map.put("ic_info", Res.drawable.ic_info)
  map.put("ic_payments", Res.drawable.ic_payments)
  map.put("ic_qr_code", Res.drawable.ic_qr_code)
  map.put("ic_stop", Res.drawable.ic_stop)
  map.put("suit_kule", Res.drawable.suit_kule)
  map.put("suit_lepsi", Res.drawable.suit_lepsi)
  map.put("suit_zaludy", Res.drawable.suit_zaludy)
  map.put("suit_zelene", Res.drawable.suit_zelene)
}
